/**
 * Los mensajes del partido.
 *
 * Van aparte de `protocol.ts` por lo mismo que los del canal social: son otra
 * conversación —la de una cancha, no la del campus— y mezclarlas invitaría a mandar una
 * por el canal de la otra.
 */
export const VolleyMsg = {
    /**
     * client -> server: "quiero moverme hacia allá".
     *
     * Va una DIRECCIÓN, no una posición, exactamente igual que `Msg.Move` en el campus.
     * El servidor integra en su tick y recorta al lado que le toca; un cliente modificado
     * no puede colocarse, y mucho menos cruzar la red.
     */
    Move: "volley:move",
    /**
     * client -> server: una de las cuatro acciones.
     *
     * `golpear` **nunca se rechaza**: existe en el piso y en el aire, y lo que cambia es
     * la física que le aplica el servidor —parábola hacia arriba desde el suelo, remate
     * directo hacia abajo en el aire—. Quien decide cuál de las dos es no es el botón que
     * el jugador ve, sino el estado que el servidor tiene: si el cliente dijera "estoy en
     * el aire", uno modificado remataría desde el suelo todo el partido.
     */
    Action: "volley:action",
    /** server -> los dos: el partido terminó, y así quedó. */
    Ended: "volley:ended",
};
/**
 * Las acciones. Viajan como TEXTO y no como índice, así que esta lista no es append-only:
 * lo que importa es que cliente y servidor la lean del mismo sitio.
 *
 * `golpear` cambia de nombre a "rematar" en pantalla mientras el jugador está en el aire,
 * pero eso es cosmética — la decisión la vuelve a tomar el servidor al recibir el mensaje.
 * `planchar` es la única que se paga con tiempo: deja al jugador en el suelo un momento.
 */
export const VOLLEY_ACTIONS = ["bloquear", "recibir", "saltar", "golpear", "planchar"];
export function isVolleyAction(value) {
    return typeof value === "string" && VOLLEY_ACTIONS.includes(value);
}
//# sourceMappingURL=protocol.js.map